import { mergeMap, debounceTime } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import * as Actions from './customs-declarations.actions';
import * as CSWActions from '../csw/csw.actions';
import * as EntitiesActions from '../../store/entities/entities.actions';

export const validateAndSave = (action$) => {
  return action$.pipe(
    ofType(Actions.CUSTOMS_DECLARATIONS_VALIDATE_CUSTOMS_AND_SAVE),
    debounceTime(500),
    mergeMap((action) => {
      const { fulfillmentPlanId, customs, needsCustoms } = action;
      const { customsItems } = customs;

      const sanitizedCustoms = {
        ...customs,
        customsItems: customsItems.map((item) => ({
          ...item,
          quantity: Number.parseFloat(item.quantity),
          unitPrice: item.unitPrice.value
            ? {
                ...item.unitPrice,
                value: Number.parseFloat(item.unitPrice.value),
              }
            : {},
        })),
      };

      // onSave patch CSW and Entities with sanitized customs
      return of(
        EntitiesActions.entitiesPatchCustoms(fulfillmentPlanId, sanitizedCustoms),
        CSWActions.updateShipmentConfiguration(fulfillmentPlanId, {
          customs: needsCustoms ? sanitizedCustoms : null,
        }),
      );
    }),
  );
};
